const state = {
    data: {}
}

const getters = {
    getDataConnectLine() {
        return state.data;
    }
}

const mutations = {
    async setDataConnectLine(data, caller = null) {
       let dataEvent = data.split('||');
       let dataCaller = caller.split('||');

       if(dataEvent[5] == 'TRANSFER') return;

       if(dataEvent[0] == 'Ligação Ativa'){
           state.data = {
                queue: dataEvent[0],
                name: dataEvent[1],
                phone: dataEvent[1],
                ticket: dataEvent[2],
                cpfCnpj: dataCaller[1],
                type: 'phone'
           }
       } else {
        if(dataEvent[1] == 'DDR'){
            state.data = {
                queue: 'Discagem direta',
                name: dataEvent[2],
                phone: dataEvent[2],
                ticket: dataEvent[3] || '---',
                cpfCnpj: '---',
                type: 'phone'
            }
        } else if(dataEvent[1] == 'DDRAGENT'){
            state.data = {
                queue: dataEvent[3],
                name: dataEvent[2],
                phone: dataEvent[2],
                orderNumber: dataEvent[6] || '---',
                ticket: dataEvent[4] || '---',
                cpfCnpj: dataEvent[5] || '---',
                type: 'phone'
            }
        } else {
            state.data = {
                 queue: dataEvent[0],
                 name: dataEvent[1],
                 phone: dataEvent[1],
                 ticket: dataEvent[2],
                 cpfCnpj: dataEvent[4],
                 orderNumber: dataEvent[5] || '---',
                 type: 'phone'
            }
        }
    }

       return state.data;
    },

    async delDataConnectLine() {
        state.data = {}
    },

    async setChatData(data){
        state.data = {
            ticket: data.ticket, 
            phone: data.phone,
            cpfCnpj: data.cpfCnpj,
            type: data.channel,
            name: data.name,
            queue: data.queue,
            orderNumber: data.orderNumber,
            sessionDate: data.sessionDate || null,
        };
        return state.data;
    }
}

export default {
    state,
    getters,
    mutations
}
